<script setup lang="ts">
withDefaults(
  defineProps<{
    small?: boolean;
  }>(),
  {
    small: false,
  },
);
</script>

<template>
  <NuxtLinkLocale
    v-bind="$attrs"
    class="flex shrink-0 cursor-pointer select-none items-center"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      aria-hidden="true"
      role="img"
      class="size-7 text-primary-600"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        color="currentColor"
      >
        <path d="M11.5 22c-4.007 0-6.01 0-7.255-1.465C3 19.072 3 16.714 3 12s0-7.071 1.245-8.536S7.493 2 11.5 2s6.01 0 7.255 1.464c1.002 1.18 1.198 2.937 1.236 6.036M8 8h7m-7 5h3" /><path d="M19.61 18.105A3.375 3.375 0 0 0 17.625 12h-.251a3.375 3.375 0 0 0-1.984 6.105m4.218 0a3.36 3.36 0 0 1-1.984.645h-.25a3.36 3.36 0 0 1-1.984-.645m4.218 0l.583 1.835c.222.7.334 1.05.303 1.268c-.063.454-.433.79-.87.792c-.21 0-.524-.164-1.153-.494c-.27-.142-.404-.212-.542-.254a1.5 1.5 0 0 0-.86 0c-.138.042-.273.112-.542.254c-.629.33-.943.495-1.153.494c-.437-.002-.807-.338-.87-.792c-.03-.218.08-.568.303-1.268l.583-1.835" />
      </g>
    </svg>
    <p class="ml-2 text-xl font-black text-primary-600">
      <span :class="{ 'sr-only': small }">Contrat</span> IA
    </p>
  </NuxtLinkLocale>
</template>
